import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { addOneNotification } from 'src/core/redux/actions';
import { Email } from 'src/models';
import messages from 'src/components/OligoDNA/messages';

import EmailFormComponent from './EmailFormComponent';

const EmailFormContainer = ({
  handleShareOrder,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const [formState, setFormState] = useState(Email.DEFAULT_EMAIL_STATE);
  const [errorEmails, setErrorEmails] = useState(null);
  const [emails, setEmails] = React.useState([]);
  const onChangeInput = (value, isValid) => {
    setFormState({
      value,
      isValid
    });
  };

  const handleEmailAddition = () => {
    setEmails([...emails, formState]);
    setFormState(Email.DEFAULT_EMAIL_STATE);
  };

  const handleDeleteEmail = (email) => {
    const newEmails = emails.filter((item) => item.value !== email.value);

    setEmails([...newEmails]);
  };

  const onSubmit = async () => {
    setErrorEmails(null);

    const emailsList = emails.map((item) => item.value);
    const response = await handleShareOrder(emailsList);

    if (response.emailAddresses?.length) {
      const successfulEmails = response.emailAddresses.reduce(
        (prevName, currentName) => `${prevName.value}, ${currentName.value}`
      );

      const message = { ...messages.emailApiSuccessMsg, values: { successfulEmails } };

      onSuccess?.();

      dispatch(addOneNotification({
        type: 'success',
        message
      }));

      return;
    }

    if (!response.emailAddresses) {
      const errEmails = emailsList.reduce(
        (prevName, currentName) => `${prevName.value}, ${currentName.value}`
      );

      setErrorEmails({ ...messages.emailApiFailureMsg, values: { errEmails } });
    }
  };

  return (
    <EmailFormComponent
      onChangeInput={onChangeInput}
      formState={formState}
      onSubmit={onSubmit}
      errorEmails={errorEmails}
      setErrorEmails={setErrorEmails}
      emails={emails}
      handleEmailAddition={handleEmailAddition}
      handleDeleteEmail={handleDeleteEmail}
    />
  );
};

EmailFormContainer.propTypes = {
  handleShareOrder: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default EmailFormContainer;
